import { render, staticRenderFns } from "./ButtonExportPostsV2.vue?vue&type=template&id=aaaba3a2&scoped=true"
import script from "./ButtonExportPostsV2.vue?vue&type=script&lang=js"
export * from "./ButtonExportPostsV2.vue?vue&type=script&lang=js"
import style0 from "./ButtonExportPostsV2.vue?vue&type=style&index=0&id=aaaba3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaba3a2",
  null
  
)

export default component.exports